import { getContext, setContext } from "svelte";
const contextKey = Symbol("InstantSearch:indexContext");
export function setIndexContext(index) {
    setContext(contextKey, index);
}
export function getIndexContext() {
    return getContext(contextKey);
}
